import { useMutation } from '@tanstack/react-query';
import useGetMutationFn from '../use-get-mutation-fn';

type MutationPayload = { schedule_id: string };

type MutationResponse = {
  status: number;
  data: { success: boolean };
};

export const useCancelScheduledMessageMutation = () => {
  const mutationFn = useGetMutationFn<MutationPayload, MutationResponse>({
    defaultErrorMessage: 'An unexpected error occurred while canceling the scheduled message',
    endpoint: ({ schedule_id }) => `/api/admin/whatsapp/scheduled/${schedule_id}`,
    method: 'DELETE',
  });

  return useMutation<MutationResponse, Error, MutationPayload>({ mutationFn });
};
